<template>
    <div class="loading" v-if="flag">
        <div class="loading-img">
            <img src="../assets/ebbly_loading.gif" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name:'loading',
    data(){
        return{
        }
    },
    props:{
        flag:{
            type:Boolean,
            default:false,
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "../sass/app";
    .loading{
        position: fixed;
        z-index: 2014;
        top:0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color:rgba(0,0,0,.5);
        .loading-img{
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 300px;
            height: 210px;
            margin: 0 auto;
            border-radius:20px ;
            img{
                width: 200px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue